import { Link, styled, LinkProps } from "@mui/material";

const StyledFooterLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: "inherit",
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

const FooterLink = (props: LinkProps) => {
  return <StyledFooterLink data-testid="footer-link" {...props} />;
};

export default FooterLink;
